import api from './api';

export interface Payment {
  id: string;
  userId: string;
  invoiceId?: string;
  payslipId?: string;
  amount: number;
  paymentDate: string;
  method: 'bank_transfer' | 'card' | 'cash' | 'check' | 'other';
  status?: 'pending' | 'approved' | 'sent' | 'cancelled';
  direction?: 'incoming' | 'outgoing';
  paymentType?: 'invoice' | 'payroll_contribution';
  reference?: string;
  notes?: string;
  createdAt: string;
  // Populated when joined
  invoiceNumber?: string;
  invoiceCurrency?: string;
  clientName?: string;
  employeeName?: string;
  payPeriodStart?: string;
  payPeriodEnd?: string;
  payslipCurrency?: string;
}

export interface CreatePaymentData {
  invoiceId?: string;
  payslipId?: string;
  amount: number;
  paymentDate: string;
  method: 'bank_transfer' | 'card' | 'cash' | 'check' | 'other';
  status?: 'pending' | 'approved' | 'sent' | 'cancelled';
  direction?: 'incoming' | 'outgoing';
  reference?: string;
  notes?: string;
}

export interface UpdatePaymentData {
  amount?: number;
  paymentDate?: string;
  method?: 'bank_transfer' | 'card' | 'cash' | 'check' | 'other';
  status?: 'pending' | 'approved' | 'sent' | 'cancelled';
  direction?: 'incoming' | 'outgoing';
  reference?: string;
  notes?: string;
}

export interface PaymentFilters {
  invoiceId?: string;
  paymentType?: 'invoice' | 'payroll_contribution';
  startDate?: string;
  endDate?: string;
}

export const paymentsApi = {
  getAll: async (filters?: PaymentFilters): Promise<Payment[]> => {
    const params = new URLSearchParams();
    if (filters?.invoiceId) params.append('invoiceId', filters.invoiceId);
    if (filters?.paymentType) params.append('paymentType', filters.paymentType);
    if (filters?.startDate) params.append('startDate', filters.startDate);
    if (filters?.endDate) params.append('endDate', filters.endDate);

    const queryString = params.toString();
    const url = `/payments${queryString ? `?${queryString}` : ''}`;
    const response = await api.get(url);
    return response.data.data;
  },

  getById: async (id: string): Promise<Payment> => {
    const response = await api.get(`/payments/${id}`);
    return response.data.data;
  },

  create: async (data: CreatePaymentData): Promise<Payment> => {
    const response = await api.post('/payments', data);
    return response.data.data;
  },

  update: async (id: string, data: UpdatePaymentData): Promise<Payment> => {
    const response = await api.put(`/payments/${id}`, data);
    return response.data.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/payments/${id}`);
  },
};



